import React from 'react';

const SelectedCheckbox = ({ color = 'currentColor' }: { color: string }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.875 4.625H15.125C16.6438 4.625 17.875 5.85622 17.875 7.375V15.625C17.875 17.1438 16.6438 18.375 15.125 18.375H6.875C5.35622 18.375 4.125 17.1438 4.125 15.625V7.375C4.125 5.85622 5.35622 4.625 6.875 4.625ZM2.75 7.375C2.75 5.09683 4.59683 3.25 6.875 3.25H15.125C17.4032 3.25 19.25 5.09683 19.25 7.375V15.625C19.25 17.9032 17.4032 19.75 15.125 19.75H6.875C4.59683 19.75 2.75 17.9032 2.75 15.625V7.375ZM16.2344 8.74304C16.4306 8.93736 16.4321 9.25394 16.2378 9.45014L10.67 15.0717C10.1642 15.5727 9.36741 15.6003 8.82945 15.1573L8.72547 15.0624L5.6392 11.9466C5.44487 11.7504 5.44638 11.4339 5.64257 11.2395L6.23461 10.6531C6.43081 10.4588 6.7474 10.4603 6.94172 10.6565L9.70201 13.4433L14.9352 8.16C15.1295 7.96382 15.4461 7.9623 15.6423 8.15661L16.2344 8.74304Z"
        fill={color}
      />
    </svg>
  );
};

export default SelectedCheckbox;
